const VideoCameraIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M12 9.74995L15.9172 12.3615C15.9737 12.399 16.0393 12.4206 16.1071 12.4238C16.1748 12.4271 16.2422 12.4119 16.302 12.3799C16.3618 12.3478 16.4118 12.3002 16.4467 12.242C16.4815 12.1838 16.5 12.1173 16.5 12.0495V5.90245C16.5 5.83647 16.4826 5.77165 16.4496 5.71454C16.4165 5.65743 16.369 5.61005 16.3118 5.57718C16.2546 5.54431 16.1897 5.52712 16.1237 5.52735C16.0577 5.52757 15.993 5.5452 15.936 5.57845L12 7.87495"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 4.5H3C2.17157 4.5 1.5 5.17157 1.5 6V12C1.5 12.8284 2.17157 13.5 3 13.5H10.5C11.3284 13.5 12 12.8284 12 12V6C12 5.17157 11.3284 4.5 10.5 4.5Z"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default VideoCameraIcon;
